<template>
  <div>
    <div id="appComponent">
      <keep-alive>
        <Header />
      </keep-alive>
      <router-view v-slot="{ Component }" class="">
        <component :is="Component" />
      </router-view>
    </div>
    <keep-alive>
      <Fouter />
    </keep-alive>
  </div>
</template>

<script>
import Fouter from "./components/Fouter.vue";
import Header from "./components/Header.vue";
import { numVisual } from "./service/firebase";
export default {
  name: "App",
  components: {
    Fouter,
    Header,
  },
  beforeCreate() {
    //this.$store.dispatch("setLanguage", "ita");
    this.$store.dispatch("setScreenWidth", window.innerWidth);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
      numVisual();
    });
  },
  methods: {
    onResize() {
      this.$store.dispatch("setScreenWidth", window.innerWidth);
    },
  },
  watch: {
    $route() {
      document.getElementById("appComponent").scrollIntoView();
    },
  },
};
</script>

<style lang="scss">
:root {
  --heightFouter: 0px;
  --color1: #112032;
  --color2: #659dbd; // #49c5b6;
  --color3: #ffffff;
  --workSize:2.5rem;
  --workTopOption:1.75rem;
  --projectSize:15rem;
  --descriptionWorkSize:2rem;
}
* {
  font-family: "Lato", sans-serif;
}

.bg-color-1 {
  background-color: var(--color2);
}

#appComponent {
  min-height: calc(100vh - var(--heightFouter));
}

body {
  margin: 0;
  background-color: var(--color1);
}
i {
  color: var(--color2);
}
div,
p,
a,
span {
  color: var(--color3);
}

.bounce-and-fade-enter-active {
  animation: bounce-and-fade 500ms ease-out;
}

.bounce-and-fade-leave-active {
  animation: slide-and-fade 500ms ease;
}

@keyframes bounce-and-fade {
  0% {
    transform: translateY(200px);
    opacity: 0;
  }
  95% {
    transform: translateY(-10px);
    opacity: 0.95;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}

@keyframes slide-and-fade {
  0% {
    transform: translateX(0px);
    opacity: 1;
  }
  10% {
    transform: translateX(-20px);
    opacity: 0.95;
  }
  100% {
    transform: translateX(100vw);
    opacity: 0;
  }
}

.grid {
  margin: 0 !important;
}
/**
.readme-mask--vertical-1 {
    -webkit-mask: url(/images/modules/site/readme/mask-vertical-1.svg) no-repeat center;
    mask: url(/images/modules/site/readme/mask-vertical-1.svg) no-repeat center;
    -webkit-mask-size: contain;
    mask-size: contain;
} */
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px var(--color2);
  background-color: #f5f5f5;
}

::-webkit-scrollbar {
  width: 6px;
  background-color: var(--color2) !important;
}

::-webkit-scrollbar-thumb {
  background-color: var(--color1);
}
</style>
